export const regex = {
  alphanumeric: {
    pattern: /^[a-zA-Z0-9]+$/,
    feedback: 'Only alphanumeric characters are allowed.',
  },
  creditCard: {
    pattern: /^\d{4}-\d{4}-\d{4}-\d{4}$/,
    feedback: 'Please enter a valid credit card number in the format XXXX-XXXX-XXXX-XXXX.',
  },
  creditCardExpiration: {
    pattern: /^(0[1-9]|1[0-2])\/\d{4}$/,
    feedback: "Please enter a valid credit card expiration date in the format 'MM/YYYY'.",
  },
  cryptoAddress: {
    pattern: /^[0-9a-fA-F]{40}$/,
    feedback: 'Please enter a valid crypto address consisting of 40 hexadecimal characters.',
  },
  date: {
    pattern: /^\d{4}-\d{2}-\d{2}$/,
    feedback: 'Please enter a valid date in the format YYYY-MM-DD.',
  },
  domainName: {
    pattern: /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,})(:\d{2,5})?(\/[^\s]*)?$/,
    feedback: 'Please enter a valid domain name, including http/https protocol if applicable.',
  },
  email: {
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    feedback: 'Please enter a valid email address.',
  },
  facebookProfileURL: {
    pattern: /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9.-]+\/?$/,
    feedback: 'Please enter a valid Facebook profile URL.',
  },
  githubUsername: {
    pattern: /^[a-zA-Z\d](?:[a-zA-Z\d]|-(?=[a-zA-Z\d])){0,38}$/,
    feedback:
      'Please enter a valid GitHub username, which can only contain alphanumeric characters or hyphens, and must start and end with an alphanumeric character.',
  },
  hexColor: {
    pattern: /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/,
    feedback: 'Please enter a valid hex color code.',
  },
  instagramUsername: {
    pattern: /^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9_.]+\/?$/,
    feedback: 'Please enter a valid Instagram username or profile URL.',
  },
  IPv4Address: {
    pattern:
      /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.([25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.([25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.([25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/,
    feedback: 'Please enter a valid IPv4 address.',
  },
  lettersAndNumbers: {
    pattern: /^[a-zA-Z0-9\s_-]+$/,
    feedback: 'Only letters, numbers, spaces, underscores, and hyphens are accepted.',
  },
  linkedinProfileURL: {
    pattern: /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]+\/?$/,
    feedback: 'Please enter a valid LinkedIn profile URL.',
  },
  password: {
    pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
    feedback:
      'Password must be at least 8 characters long and include at least one digit, one lowercase, and one uppercase letter.',
  },
  phone: {
    pattern: /^\+(?:[0-9] ?){6,14}[0-9]$/,
    feedback: 'Please enter a valid international phone number.',
  },
  positiveInteger: {
    pattern: /^\d+$/,
    feedback: 'Please enter a positive integer.',
  },
  positiveNumber: {
    pattern: /^\d+(\.\d+)?$/,
    feedback: 'Please enter a valid positive floating-point number.',
  },
  semanticVersion: {
    pattern: /^\d+\.\d+\.\d+$/,
    feedback: "Please enter a valid semantic version number in the format 'X.Y.Z'.",
  },
  slug: {
    pattern: /^[a-z0-9-]+$/,
    feedback: 'Please enter a valid slug containing only lowercase letters, numbers, and hyphens.',
  },
  socialSecurityNumber: {
    pattern: /^\d{3}-\d{2}-\d{4}$/,
    feedback: 'Please enter a valid Social Security Number in the format XXX-XX-XXXX.',
  },
  strongPassword: {
    pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).{8,}$/,
    feedback:
      'Password must be at least 8 characters long and include at least one digit, one lowercase letter, one uppercase letter, and one special character (@#$%^&+=).',
  },
  tags: {
    pattern: /^[a-zA-Z0-9\s,#+_-]+$/,
    feedback:
      'Tags can only contain letters, numbers, spaces, commas, hash symbols (#), underscores, and hyphens.',
  },
  time24h: {
    pattern: /^([01]\d|2[0-3]):[0-5]\d$/,
    feedback: 'Please enter a valid 24-hour time in the format HH:MM.',
  },
  twitterProfileURL: {
    pattern: /^(https?:\/\/)?(www\.)?twitter\.com\/[a-zA-Z0-9_]+\/?$/,
    feedback: 'Please enter a valid Twitter profile URL.',
  },
  twitterUsername: {
    pattern: /^@[a-zA-Z0-9_]{1,15}$/,
    feedback:
      "Please enter a valid Twitter username starting with '@', containing 1-15 alphanumeric characters or underscores.",
  },
  url: {
    pattern: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
    feedback: 'Please enter a valid URL.',
  },
  uuid: {
    pattern:
      /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-4[a-fA-F0-9]{3}-[89aAbB][a-fA-F0-9]{3}-[a-fA-F0-9]{12}$/,
    feedback: 'Please enter a valid UUID.',
  },
  youtubeVideoID: {
    pattern: /^[a-zA-Z0-9_-]{11}$/,
    feedback: 'Please enter a valid YouTube video ID consisting of 11 characters.',
  },
  youtubeVideoURL: {
    pattern:
      /^(https?:\/\/)?(www\.)?youtube\.com\/(watch\?v=|embed\/|v\/|playlist\?list=)([a-zA-Z0-9_-]{11})/,
    feedback: 'Please enter a valid YouTube video URL.',
  },
}
